import React from 'react'
import { Grid, Stepper, Step, StepButton, StepContent, StepLabel } from '@material-ui/core'
import { sm } from '../../../utils/ResponsiveUtility'
import { CreateInvoiceProvider, CreateInvoiceConsumer } from '../../../context/CreateInvoiceContext'
import { useStyles, InvoiceStepsConnector, InvoiceStepIconStyles } from './Styles'
import { FormLoader } from '../../Loader/FormLoader'
import { LanguageConsumer } from '../../../context/LanguageContext'
import { AuthConsumer } from '../../../context/AuthContext'

const InvoiceSteps = () => {
  const classes = useStyles()
  const [savedEntityId, setSavedEntityId] = React.useState(null)
  const [savedEntityType, setSavedEntityType] = React.useState('draft')
  let [width, setWidth] = React.useState(document.body.clientWidth)
  let Mobile = (width < sm)

  React.useEffect(() => {
    const getWidth = () => {
      setWidth(document.body.clientWidth)
    }
    window.addEventListener('resize', getWidth)
    return () => {
      window.removeEventListener('resize', getWidth)
    }
  }, [width])

  const requestStepIcon = (props, icon) => {
    const classes = InvoiceStepIconStyles()
    const { active, completed } = props
    let iconClasses = [classes.root]
    if (!!active) iconClasses.push(classes.active)
    if (!!completed) iconClasses.push(classes.completed)
    return (
      <div className={iconClasses.join(' ')}>
        {icon}
      </div>
    )
  }


  React.useEffect(() => {
    let search = window.location.search
    let params = new URLSearchParams(search)
    let draftId = params.get('draftId')
    let templateId = params.get('templateId')
    let invoiceUUID = params.get('invoiceUUID')
    if (!!draftId) {
      setSavedEntityId(draftId)
      setSavedEntityType('draft')
    } else if (!!templateId) {
      setSavedEntityId(templateId)
      setSavedEntityType('template')
    } else if (!!invoiceUUID) {
      setSavedEntityId(invoiceUUID)
      setSavedEntityType('invoice')
    }

  }, [])

  return (
    <LanguageConsumer>
      {({ locale }) => (
        <AuthConsumer>
          {({ taxpayerData }) => (
            <CreateInvoiceProvider savedEntityId={savedEntityId} savedEntityType={savedEntityType} locale={locale}
                                   trn={taxpayerData?.trn?.toString()}>
              <CreateInvoiceConsumer>
                {({ invoiceActiveStep, invoiceSteps, getInvoiceStepContent, handleGoToStep, isInvoiceStepComplete, inInvoiceStepsTrail, draftInvoiceLoading }) => (
                  <>
                    {!!draftInvoiceLoading && <FormLoader loading={true}/>}
                    <Stepper className={classes.StepperWrapper}
                             activeStep={invoiceActiveStep} {...!!Mobile ? { orientation: 'vertical' } : {
                      connector: <InvoiceStepsConnector/>, alternativeLabel: true
                    }}>
                      {invoiceSteps.map((step, index) => (
                        <Step key={index} className={!!step?.hide ? 'hidden' : ''}>
                          <StepButton
                            disableRipple
                            onClick={() => !step?.hide ? handleGoToStep(index) : false}
                            completed={isInvoiceStepComplete(index)}
                            disabled={!(isInvoiceStepComplete(index) || inInvoiceStepsTrail(index))}
                          >
                            <StepLabel
                              StepIconComponent={(props) => requestStepIcon(props, step.icon)}>{step.title}</StepLabel>
                          </StepButton>
                          {!!Mobile && !step?.hide &&
                          <StepContent>
                            {getInvoiceStepContent(index)}
                          </StepContent>
                          }
                        </Step>
                      ))}
                    </Stepper>
                    {!Mobile &&
                    <Grid container>
                      {getInvoiceStepContent(invoiceActiveStep)}
                    </Grid>
                    }
                  </>
                )}
              </CreateInvoiceConsumer>
            </CreateInvoiceProvider>
          )}
        </AuthConsumer>
      )}
    </LanguageConsumer>
  )
}
export default InvoiceSteps
